import { FC, HTMLAttributes } from "react";
import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import Avatar from "src/Components/Avatar";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import __ from "src/utils/Translations";

interface IEmployeesAutocompleteOptionProps {
  liProps: HTMLAttributes<HTMLLIElement> & {
    key: unknown;
  };
  option: IEmployeeDetails;
}

const EmployeesAutocompleteOption: FC<IEmployeesAutocompleteOptionProps> = ({
  liProps,
  option,
}) => (
  <ListItem
    {...liProps}
    key={option.employeeId}
    alignItems="center"
    sx={{ display: "flex", alignItems: "center", paddingY: "6px" }}
  >
    <ListItemAvatar>
      <Avatar
        src={option.avatarUrl}
        initials={option.initials ?? ""}
        employeePresence={option?.presenceStatus}
      />
    </ListItemAvatar>
    <ListItemText
      sx={{ ml: 1 }}
      primary={
        <Typography variant="body1" fontWeight={700} fontSize="0.875rem">
          {`${option.firstName} ${option.lastName}`}
        </Typography>
      }
      secondary={
        <>
          <Typography variant="body2" color="text.secondary" fontSize="0.75rem">
            {option.position || __("Brak stanowiska")}
          </Typography>
          <Typography variant="body2" color="text.secondary" fontSize="0.75rem">
            {__("Numer kadrowy")}: {option.fkNumber}
          </Typography>
        </>
      }
    />
  </ListItem>
);

export default EmployeesAutocompleteOption;
